"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var utils_1 = require("./_internal/utils");
var peek_1 = tslib_1.__importDefault(require("./Lazy/peek"));
var pipe_1 = tslib_1.__importDefault(require("./pipe"));
var sum_1 = tslib_1.__importDefault(require("./sum"));
/**
 * Returns the average of the given (Iterable/AsyncIterable) (mean)
 *
 * @example
 * ```ts
 * average([]); // NaN
 * average([1, 2, 3, 4, 5]); // 3
 * await average(toAsync([1, 2, 3, 4, 5])); // 3
 *
 * // with pipe
 * pipe(
 *  [1, 2, 3, 4, 5],
 *  average,
 * ); // 3
 * ```
 *
 * see {@link https://fxts.dev/docs/pipe | pipe}
 */
function average(iterable) {
    var size = 0;
    if ((0, utils_1.isIterable)(iterable)) {
        return (0, pipe_1.default)(iterable, (0, peek_1.default)(function () { return size++; }), sum_1.default, function (a) { return (size === 0 ? NaN : a / size); });
    }
    if ((0, utils_1.isAsyncIterable)(iterable)) {
        return (0, pipe_1.default)(iterable, (0, peek_1.default)(function () { return size++; }), sum_1.default, function (a) { return (size === 0 ? NaN : a / size); });
    }
    throw new TypeError("'iterable' must be type of Iterable or AsyncIterable");
}
exports.default = average;
//# sourceMappingURL=average.js.map